import React, {useEffect, useState, useLayoutEffect} from "react";
import "./App.css";
import Swal from "sweetalert2";
import {FaInstagram, FaLinkedinIn, FaFacebookF} from "react-icons/fa";
const API_URL = "https://api.menomind.org/api/NominationDetails";
//const API_URL = "https://localhost:7216/api/NominationDetails";

export default function Home() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [wordCount, setWordCount] = useState(0);
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                        observer.unobserve(entry.target);
                    }
                });
            },
            {threshold: 0.1}
        );

        document.querySelectorAll(".fade-in").forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            const form = e.currentTarget;
            const formData = new FormData(form);
            const payload = new FormData();

            // =========================
            // NOMINATOR DETAILS
            // =========================

            payload.append("NominatorFullName", formData.get("nominatorFullName") || "");
            payload.append("NominatorProfessionalDesignation", formData.get("nominatorProfessionalDesignation") || "");
            payload.append("NominatorEmailId", formData.get("nominatorEmailId") || "");
            payload.append("NominatorMobileNo", formData.get("nominatorMobileNo") || "");
            payload.append("NominatorOrganisationAffiliation", formData.get("nominatorOrganisationAffiliation") || "");
            payload.append("NominatorStateCity", formData.get("nominatorStateCity") || "");
            payload.append("NominatorRelationshipToNominee", formData.get("nominatorRelationshipToNominee") || "");
            payload.append("NominatorHearAboutAwardsSource", formData.get("nominatorHearAboutAwardsSource") || "");

            payload.append("FullName", formData.get("nomineeName") || "");
            payload.append("NominationType", formData.get("nominationType") || "");
            payload.append("AwardCategory", formData.get("awardCategory") || "");
            payload.append("Specialization", formData.get("specialization") || "");
            payload.append("CurrentOrganization", formData.get("organization") || "");

            // Split city & state if needed
            const cityState = formData.get("cityState") || "";
            payload.append("City", cityState);
            payload.append("State", cityState);

            payload.append("EmailId", formData.get("email") || "");
            payload.append("MobileNo", formData.get("contactNumber") || "");
            payload.append("YearsOfContribution", formData.get("yearsContribution") || "");
            payload.append("Age", formData.get("Age") || "");
            payload.append("NomineesContribution", formData.get("contributionDetails") || "");

            payload.append("LinksToMedia", formData.get("mediaLinks") || "");

            // =========================
            // CONSENT CHECKBOXES
            // =========================
            payload.append("Consent1", formData.get("consentAccuracy") ? "true" : "false");

            payload.append("Consent2", formData.get("consentNominee") ? "true" : "false");

            payload.append("Consent3", formData.get("consentPublish") ? "true" : "false");

            payload.append("Consent4", formData.get("consentJury") ? "true" : "false");

            payload.append("Consent5", formData.get("consentUpdates") ? "true" : "false");

            payload.append("CreatedBy", "1");

            // =========================
            // FILES
            // =========================

            // CV
            const cvFile = formData.get("cv");
            if (cvFile && cvFile.size > 0) {
                payload.append("cvProfileAttachment", cvFile);
            }

            // Photo
            const photoFile = formData.get("photo");
            if (photoFile && photoFile.size > 0) {
                payload.append("photographAttachment", photoFile);
            }

            // Supporting Letter
            const supportFile = formData.get("supportLetter");
            if (supportFile && supportFile.size > 0) {
                payload.append("supportingLettersAttachment", supportFile);
            }

            // Multiple Additional Evidence Files
            const additionalFiles = formData.getAll("additionalEvidence");

            additionalFiles.forEach((file) => {
                if (file && file.size > 0) {
                    payload.append("additionalEvidencesAttachments", file);
                }
            });

            // =========================
            // API CALL
            // =========================
            const response = await fetch(API_URL, {
                method: "POST",
                body: payload,
            });

            const result = await response.json();

            console.log("API RESPONSE:", result);

            if (!response.ok) {
                throw new Error(result?.message || "Submission failed");
            }

            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Nomination submitted successfully!",
                confirmButtonColor: "#303a80",
            });

            setMessage("Nomination submitted successfully.");
            form.reset();
            setWordCount(0);
        } catch (error) {
            console.error(error);

            setMessage(error.message || "Something went wrong while submitting.");
        } finally {
            setLoading(false);
        }
    };

    const scrollToHashSection = () => {
        const hash = window.location.hash;

        if (!hash) return;

        let id = hash.replace("#", "");

        // support both live and local hash names
        if (id === "nomination") {
            id = "nominate";
        }

        const target = document.getElementById(id);

        if (target) {
            target.scrollIntoView({
                behavior: "auto",
                block: "start",
            });
        }
    };

    useLayoutEffect(() => {
        const timer1 = setTimeout(scrollToHashSection, 100);
        const timer2 = setTimeout(scrollToHashSection, 500);
        const timer3 = setTimeout(scrollToHashSection, 1000);

        window.addEventListener("load", scrollToHashSection);

        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
            clearTimeout(timer3);
            window.removeEventListener("load", scrollToHashSection);
        };
    }, []);

    return (
        <>
            <nav>
                <div className="nav-inner">
                    <a aria-label="C Positive Awards Home" className="nav-logo-wrap" href="#home">
                        <img
                            alt="C Positive Awards"
                            className="nav-logo"
                            src={require("./assests/Images/CPositiveLogo.png")}
                        />
                    </a>
                    <button
                        aria-expanded={menuOpen}
                        aria-label="Toggle navigation"
                        className={`nav-toggle ${menuOpen ? "active" : ""}`}
                        type="button"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                    <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
                        <li>
                            <a href="#about">About</a>
                        </li>
                        <li>
                            <a href="#categories">Categories</a>
                        </li>
                        <li>
                            <a href="#timeline">Timeline</a>
                        </li>
                        <li>
                            <a href="#past-editions">Moments</a>
                        </li>
                        <li>
                            <a href="#faq"></a>
                        </li>
                        <li style={{color: "white!important"}}>
                            <li>
                                <a className="nav-cta nav-cta-white" href="#nominate">
                                    Nominate Now
                                </a>
                            </li>
                        </li>
                    </ul>
                </div>
            </nav>
            <section className="hero" id="home">
                <img className="ribbon-motif" src={require("./assests/Images/WhiteRibbon.png")} alt="Ribbon Motif" />
                <img className="ribbon-motif" src={require("./assests/Images/WhiteRibbon.png")} alt="Ribbon Motif" />
                <img className="ribbon-motif2" src={require("./assests/Images/WhiteRibbon.png")} alt="Ribbon Motif" />
                <img className="ribbon-motif2" src={require("./assests/Images/WhiteRibbon.png")} alt="Ribbon Motif" />

                <div className="hero-bg"></div>
                {/* Decorative ribbon SVGs */}
                {/* <svg className="ribbon-motif" fill="none" viewBox="0 0 200 240" xmlns="http://www.w3.org/2000/svg">
  <path d="M100 10 C60 10, 20 40, 20 80 C20 130, 80 150, 100 190 C120 150, 180 130, 180 80 C180 40, 140 10, 100 10Z" fill="white"></path>
  <path d="M100 190 L80 240 L100 220 L120 240 Z" fill="white"></path>
</svg>

<svg className="ribbon-motif2" fill="none" viewBox="0 0 200 240" xmlns="http://www.w3.org/2000/svg">
  <path d="M100 10 C60 10, 20 40, 20 80 C20 130, 80 150, 100 190 C120 150, 180 130, 180 80 C180 40, 140 10, 100 10Z" fill="white"></path>
  <path d="M100 190 L80 240 L100 220 L120 240 Z" fill="white"></path>
</svg> */}
                <div className="hero-content">
                    <div className="edition-badge">Third Edition · June 2026</div>
                    <h1>
                        <span className="accent">C Positive</span>
                        <br />
                        <span className="rose">Awards</span>
                        <span style={{fontWeight: "300"}}>&nbsp;2026</span>
                    </h1>
                    <p className="hero-tagline">Honouring Extraordinary Contributions to Cancer Care</p>
                    <p className="hero-desc">
                        The C Positive Awards celebrate the visionaries, caregivers, institutions, and communities who
                        have transformed the landscape of cancer care in India and beyond — with courage, compassion,
                        and relentless dedication.
                    </p>
                    <div className="hero-actions">
                        <a className="btn-primary" href="#nominate">
                            Submit a Nomination
                        </a>
                        <a className="btn-outline" href="#about">
                            Learn More
                        </a>
                    </div>

                    <div className="hero-stats">
                        <div className="stat-item">
                            <span className="stat-num">2</span>
                            <span className="stat-label">Previous Editions</span>
                        </div>
                        <div className="stat-item">
                            <span className="stat-num">6</span>
                            <span className="stat-label">Award Categories</span>
                        </div>
                        <div className="stat-item">
                            <span className="stat-num">June</span>
                            <span className="stat-label">Ceremony 2026</span>
                        </div>
                        {/* <div className="stat-item">
                            <span className="stat-num">∞</span>
                            <span className="stat-label">Lives Impacted</span>
                        </div> */}
                    </div>
                </div>
            </section>
            <section id="about">
                <div className="section-inner fade-in">
                    <div className="section-label">About the Awards</div>
                    <h2 className="section-title">
                        Our Vision &<em>&nbsp;Mission</em>
                    </h2>
                    <p
                        style={{
                            maxWidth: "700px",
                            color: "var(--text-mid)",
                            fontSize: "1rem",
                            marginBottom: "0",
                            lineHeight: "1.8",
                        }}
                    >
                        The C Positive Awards were founded on the belief that recognition is a powerful catalyst — it
                        amplifies good work, inspires others, and reminds a weary world that extraordinary things are
                        possible.
                    </p>
                    <div className="vm-grid">
                        <div className="vm-card vision">
                            <span className="vm-icon">🌟</span>
                            <h3>Our Vision</h3>
                            <p>
                                A world where every person affected by cancer — patient, survivor, caregiver, or family
                                — has access to the best possible care, supported by a community of champions who refuse
                                to give up. The C Positive Awards envision an ecosystem where excellence in cancer care
                                is universally recognised, celebrated, and replicated.
                            </p>
                        </div>
                        <div className="vm-card mission">
                            <span className="vm-icon">🎯</span>
                            <h3>Our Mission</h3>
                            <p>
                                To identify, honour, and amplify the contributions of individuals and institutions who
                                have made a measurable difference in cancer care — through clinical innovation, patient
                                support, research, advocacy, palliative services, or community outreach — and to build a
                                national movement of C Positive leadership.
                            </p>
                        </div>
                    </div>
                    <div className="vm-pillars">
                        <div className="pillar">
                            <span className="pillar-num">01</span>
                            <h4>Recognise</h4>
                            <p>Shine a well-deserved spotlight on unsung heroes and trailblazers in cancer care.</p>
                        </div>
                        <div className="pillar">
                            <span className="pillar-num">02</span>
                            <h4>Inspire</h4>
                            <p>Motivate the next generation of oncologists, nurses, and advocates.</p>
                        </div>
                        <div className="pillar">
                            <span className="pillar-num">03</span>
                            <h4>Connect</h4>
                            <p>Build a network of changemakers committed to transforming cancer outcomes in India.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section id="categories">
                <div className="section-inner fade-in">
                    <div className="section-label">Award Categories</div>
                    <h2 className="section-title">Six categories. Countless stories of impact.</h2>
                    <p className="categories-intro">
                        Each award celebrates a distinct dimension of cancer care — from clinical excellence to
                        caregiving and survivorship.
                    </p>
                    <div className="categories-grid">
                        <div className="cat-card">
                            <div className="cat-top">
                                <div className="cat-icon">♡</div>
                                <span className="cat-number">01</span>
                            </div>
                            <h3>Patient Courage Award</h3>
                            <p>
                                Honours cancer survivors who have demonstrated exceptional resilience, strength, and a
                                positive spirit throughout their journey, inspiring others with their story.
                            </p>
                            <div className="cat-info">
                                <h4>Eligibility</h4>
                                <p>
                                    Cancer survivors of any stage/type who have shown courage and advocacy through their
                                    experience.
                                </p>
                            </div>
                            <div className="cat-info">
                                <h4>Who Should Apply / Nominate</h4>
                                <p>
                                    Survivors themselves or individuals nominating a survivor whose journey has created
                                    meaningful impact.
                                </p>
                            </div>
                        </div>
                        <div className="cat-card">
                            <div className="cat-top">
                                <div className="cat-icon">🧠</div>
                                <span className="cat-number">02</span>
                            </div>
                            <h3>Psycho-Oncology Excellence Award</h3>
                            <p>
                                Celebrates professionals contributing to the mental health and emotional well-being of
                                cancer patients through counselling, therapy, and psycho-oncology practices.
                            </p>
                            <div className="cat-info">
                                <h4>Eligibility</h4>
                                <p>
                                    Psychologists, psycho-oncologists, counsellors, and mental health professionals
                                    working in oncology settings.
                                </p>
                            </div>
                            <div className="cat-info">
                                <h4>Who Should Apply / Nominate</h4>
                                <p>Practitioners or institutions advancing psychological care in cancer treatment.</p>
                            </div>
                        </div>
                        <div className="cat-card">
                            <div className="cat-top">
                                <div className="cat-icon">🏥</div>
                                <span className="cat-number">03</span>
                            </div>
                            <h3>Institutional Excellence in Cancer Care</h3>
                            <p>
                                Recognises hospitals or institutions delivering holistic, patient-centred cancer care
                                with a strong focus on compassion, accessibility, and quality treatment.
                            </p>
                            <div className="cat-info">
                                <h4>Eligibility</h4>
                                <p>
                                    Hospitals, clinics, or cancer care centres providing comprehensive oncology
                                    services.
                                </p>
                            </div>
                            <div className="cat-info">
                                <h4>Who Should Apply / Nominate</h4>
                                <p>
                                    Institutions demonstrating excellence in treatment, patient support, and care
                                    delivery.
                                </p>
                            </div>
                        </div>
                        {/* <div className="cat-card">
              <div className="cat-top">
                <div className="cat-icon">
                  ⚗
                </div>
                <span className="cat-number">
                  04
                </span>
              </div>
              <h3>
                Research & Innovation Award
              </h3>
              <p>
                Recognises groundbreaking research, innovative approaches, or new models that enhance cancer care, early
                detection, or patient well-being.
              </p>
              <div className="cat-info">
                <h4>
                  Eligibility
                </h4>
                <p>
                  Researchers, academicians, clinicians, or innovators in oncology or related interdisciplinary fields.
                </p>
              </div>
              <div className="cat-info">
                <h4>
                  Who Should Apply / Nominate
                </h4>
                <p>
                  Individuals or teams contributing to impactful research or innovative solutions in cancer care.
                </p>
              </div>
            </div> */}
                        <div className="cat-card">
                            <div className="cat-top">
                                <div className="cat-icon">👥</div>
                                <span className="cat-number">04</span>
                            </div>
                            <h3>NGO / Community Impact Award</h3>
                            <p>
                                Honours organisations or initiatives creating meaningful change in cancer awareness,
                                support services, accessibility, or community outreach.
                            </p>
                            <div className="cat-info">
                                <h4>Eligibility</h4>
                                <p>
                                    NGOs, foundations, community groups, or social enterprises working in cancer care or
                                    support.
                                </p>
                            </div>
                            <div className="cat-info">
                                <h4>Who Should Apply / Nominate</h4>
                                <p>Organisations or leaders driving measurable social impact in cancer care.</p>
                            </div>
                        </div>
                        <div className="cat-card">
                            <div className="cat-top">
                                <div className="cat-icon">🤝</div>
                                <span className="cat-number">05</span>
                            </div>
                            <h3>Excellence in Oncology Award</h3>
                            <p>
                                Recognises oncologists who have demonstrated outstanding contribution to cancer
                                treatment, patient care, research, innovation, leadership, and compassionate oncology
                                practice.
                            </p>
                            <div className="cat-info">
                                <h4>Eligibility</h4>
                                <p>
                                    Medical, surgical, radiation, pediatric, gynecologic, hematology, or palliative
                                    oncologists, as well as multidisciplinary cancer care specialists.
                                </p>
                            </div>
                            <div className="cat-info">
                                <h4>Who Should Apply / Nominate</h4>
                                <p>
                                    Oncologists, hospitals, institutions, colleagues, patients, caregivers, or
                                    healthcare professionals wishing to recognise excellence in oncology care.
                                </p>
                            </div>
                        </div>
                        <div className="cat-card">
                            <div className="cat-top">
                                <div className="cat-icon">🏢</div>

                                <span className="cat-number">06</span>
                            </div>

                            <h3>Corporate Impact Award</h3>

                            <p>
                                Recognises corporations, CSR initiatives, and workplace programs that have made a
                                meaningful contribution to cancer care, awareness, patient support, employee wellness,
                                or community impact.
                            </p>

                            <div className="cat-info">
                                <h4>Eligibility</h4>

                                <p>
                                    Corporate organisations, CSR foundations, private companies, and industry-led
                                    initiatives actively supporting cancer-related healthcare, awareness, screening,
                                    rehabilitation, or patient welfare programs.
                                </p>
                            </div>

                            <div className="cat-info">
                                <h4>Who Should Apply / Nominate</h4>

                                <p>
                                    Companies, CSR teams, corporate leaders, or organisations driving impactful and
                                    sustainable initiatives in cancer care and community well-being.
                                </p>
                            </div>
                        </div>{" "}
                    </div>
                </div>
            </section>
            {/* <section id="eligibility">
        <div className="section-inner fade-in">
          <div className="section-label">
            Who Can Be Nominated
          </div>
          <h2 className="section-title">
            Eligibility
            <em>
              Criteria
            </em>
          </h2>
          <p className="elig-subtitle">
            The C Positive Awards are open to nominations from across India and the South Asian region. Please review all
            criteria carefully before submitting.
          </p>
          <div className="elig-grid">
            <div className="elig-block">
              <h3>
                General Eligibility — Individuals
              </h3>
              <ul className="elig-list">
                <li>
                  Must be an Indian national or have made their primary contribution within India or South Asia.
                </li>
                <li>
                  Must be actively working in, or have a proven record of contribution to, cancer care, research,
                  advocacy, or patient support.
                </li>
                <li>
                  Nominees for the Lifetime Achievement Award must have a minimum of 20 years of continuous service.
                </li>
                <li>
                  Young Oncology Leader nominees must be 40 years of age or under as of 1st January 2026.
                </li>
                <li>
                  Deceased individuals may be nominated posthumously, with the award accepted by next of kin.
                </li>
                <li>
                  Self-nominations are accepted, provided all supporting documentation is included.
                </li>
                <li>
                  Previous winners are eligible for nomination in a different category after a gap of two editions.
                </li>
              </ul>
            </div>
            <div className="elig-block">
              <h3>
                General Eligibility — Institutions
              </h3>
              <ul className="elig-list">
                <li>
                  Must be a registered hospital, cancer centre, research body, NGO, or healthcare organisation operating
                  in India.
                </li>
                <li>
                  Must have been in active operation for a minimum of three years prior to the nomination deadline.
                </li>
                <li>
                  Organisations must demonstrate measurable, documented impact on cancer care delivery or outcomes.
                </li>
                <li>
                  Commercial pharmaceutical or device companies are not eligible as institutional nominees (individuals
                  from such companies may be nominated).
                </li>
                <li>
                  Institutions may be nominated by any of their staff members, board members, or an external nominator.
                </li>
                <li>
                  Partnerships or multi-institutional projects may be nominated as a single entity.
                </li>
              </ul>
            </div>
            <div className="elig-block">
              <h3>
                Nomination Requirements
              </h3>
              <ul className="elig-list">
                <li>
                  A fully completed online nomination form (no incomplete nominations will be assessed).
                </li>
                <li>
                  A detailed nominator's statement (500–800 words) outlining the nominee's impact.
                </li>
                <li>
                  At least two supporting letters from peers, patients, or professional bodies.
                </li>
                <li>
                  A current curriculum vitae or institutional profile.
                </li>
                <li>
                  Evidence of impact: data, publications, patient testimonials, media coverage, or case studies.
                </li>
                <li>
                  A recent photograph of the nominee (minimum 300 DPI) or institutional logo.
                </li>
              </ul>
            </div>
            <div className="elig-block">
              <h3>
                Nominator Eligibility
              </h3>
              <ul className="elig-list">
                <li>
                  Any individual aged 18 years or above may submit a nomination.
                </li>
                <li>
                  Nominators may be healthcare professionals, patients, caregivers, researchers, journalists, or members
                  of the public.
                </li>
                <li>
                  A single nominator may submit nominations in up to three categories.
                </li>
                <li>
                  Nominators must not be a direct family member of the individual nominee.
                </li>
                <li>
                  Nominators will be required to verify their identity and contact details.
                </li>
                <li>
                  Anonymous nominations will not be accepted.
                </li>
              </ul>
            </div>
          </div>
          <div className="disqualify">
            <h3>
              Grounds for Disqualification
            </h3>
            <ul className="elig-list">
              <li>
                Incomplete, falsified, or plagiarised nomination materials will be immediately disqualified.
              </li>
              <li>
                Nominees found to have engaged in professional misconduct, fraud, or ethical violations will be
                ineligible.
              </li>
              <li>
                Nominations received after the published deadline will not be assessed under any circumstances.
              </li>
              <li>
                Current members of the C Positive Awards jury or organising committee are not eligible for nomination.
              </li>
            </ul>
          </div>
        </div>
      </section> */}
            <section id="timeline">
                <div className="section-inner fade-in">
                    <div className="section-label">Key Dates</div>
                    <h2 className="section-title" style={{textAlign: "center"}}>
                        Awards&nbsp;
                        <em>Timeline</em>
                    </h2>
                    <div className="timeline">
                        <div className="tl-item">
                            <div className="tl-dot">1</div>
                            <div className="tl-content">
                                <span className="tl-date">15th May 2026</span>
                                <h4>Nominations Open</h4>
                                <p>
                                    The online nomination portal goes live. Begin gathering supporting documents and
                                    letters ahead of time.
                                </p>
                            </div>
                        </div>
                        <div className="tl-item deadline">
                            <div className="tl-dot">2</div>
                            <div className="tl-content">
                                <span className="tl-date">15th June 2026 · Last Date</span>
                                <h4>Nomination Deadline</h4>
                                <p>
                                    All nominations, supporting letters, and documents must be submitted by 11:59 PM
                                    IST. No extensions will be granted.
                                </p>
                            </div>
                        </div>
                        <div className="tl-item">
                            <div className="tl-dot">3</div>
                            <div className="tl-content">
                                <span className="tl-date">16th – 19th June 2026</span>
                                <h4>Shortlisting & Jury Review</h4>
                                <p>
                                    The review committee reviews all nominations for eligibility. Shortlisted
                                    nominations are then forwarded to the independent expert jury.
                                </p>
                            </div>
                        </div>

                        <div className="tl-item">
                            <div className="tl-dot">4</div>
                            <div className="tl-content">
                                <span className="tl-date">20th June 2026</span>
                                <h4>Finalists Announced</h4>
                                <p>
                                    Finalists are notified and publicly announced via the awards website and official
                                    communications.
                                </p>
                            </div>
                        </div>
                        <div className="tl-item closed">
                            <div className="tl-dot">★</div>
                            <div className="tl-content">
                                <span className="tl-date" style={{color: "var(--gold)"}}>
                                    28 June 2026
                                </span>
                                <h4>C Positive Awards Ceremony</h4>
                                <p>
                                    The grand felicitation ceremony, bringing together the cancer care community to
                                    honour this year's extraordinary winners.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="chief-guest" className="chief-guest-section">
                <div className="section-inner fade-in">
                    <div className="section-label">Chief Guests</div>

                    <h2 className="section-title" style={{textAlign: "center"}}>
                        Honouring the Event with Our&nbsp;
                        <em>Chief Guests</em>
                    </h2>

                    <p className="section-subtitle">
                        Distinguished guests joining us to celebrate courage, care, and impact in the cancer care
                        community.
                    </p>

                    <div className="chief-guests-grid">
                        {[
                            {
                                img: require("./assests/Images/RamanSir.png"),
                                name: "Dr. Raman Gangakhedkar",
                                role: "Padmashree | Indian epidemiologist",
                            },
                            {
                                img: require("./assests/Images/RenukaMam.png"),
                                name: "Renuka Shahane",
                                role: "Veteran Actor | Filmmaker | Writer",
                            },
                        ].map((guest, index) => (
                            <div className="chief-guest-card" key={index}>
                                <div className="chief-guest-photo">
                                    <img src={guest.img} alt={guest.name} />
                                </div>

                                <div className="chief-guest-info">
                                    {/* <span>Distinguished Guests</span> */}
                                    <h3>{guest.name}</h3>
                                    <p>{guest.role}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section id="past-editions">
                <div className="section-inner fade-in">
                    <div className="section-label">Past Editions · 2024 & 2025</div>
                    <h2 className="section-title">
                        Moments that moved hearts and&nbsp;
                        <br className="desktop-break" />
                        built a community of hope.
                    </h2>
                    <p className="past-intro">
                        From powerful survivor stories to inspiring leaders in healthcare, research and social impact —
                        a glimpse into the journey so far.
                    </p>
                    <div className="edition-hero">
                        <div className="edition-content">
                            <span className="edition-kicker">C Positive Awards</span>
                            <h3>2025 Edition</h3>
                            <p className="edition-date">13 July 2025</p>
                            <p>
                                Honoured exemplary contributions across psycho-oncology, caregiving, research and
                                oncology — celebrating empathy, clinical excellence and innovation in holistic cancer
                                care.
                            </p>
                        </div>
                        <div className="edition-stats">
                            <div className="stat-box">
                                <span>150</span>
                                <p>attendees</p>
                            </div>
                            <div className="stat-box">
                                <span>5</span>
                                <p>awardees</p>
                            </div>
                        </div>
                    </div>
                    <div className="guest-section">
                        <div className="small-label">Chief Guests</div>
                        <div className="guest-grid">
                            <div className="guest-card">
                                <div className="guest-photo">
                                    <img
                                        alt="Dr. Vibha Bafna receiving award"
                                        src={require("./assests/Images/MaheshSir.png")}
                                    />
                                </div>
                                <span className="guest-role">Chief Guest</span>
                                <h4>Dr. Mahesh Murlidhar Bhagwat</h4>
                                <p>ADG, Law & Order, Telangana</p>
                            </div>
                            <div className="guest-card">
                                <div className="guest-photo">
                                    <img
                                        alt="Dr. Vibha Bafna receiving award"
                                        src={require("./assests/Images/DeglurkarSir.png")}
                                    />
                                </div>
                                <span className="guest-role">Chief Guest</span>
                                <h4>Dr. G.B. Deglurkar</h4>
                                <p>Former Chancellor, Deccan College</p>
                            </div>
                        </div>
                    </div>
                    <div className="moments-section">
                        <div className="small-label">Moments from 2025</div>
                        <div className="moments-grid">
                            <div className="moment-card">
                                <img
                                    alt="Felicitation on stage"
                                    src={require("./assests/Images/CpositivePoonam.jpeg")}
                                />
                                <p>Ms. Poonam Nanda · Awardee</p>
                            </div>
                            <div className="moment-card">
                                <img
                                    alt="Award of Honour"
                                    src={require("./assests/Images/CpositveAnantbhushan.jpeg")}
                                />
                                <p>Dr. Anantbhushan Ranade · Awardee</p>
                            </div>
                            <div className="moment-card">
                                <img
                                    alt="Honouring a changemaker"
                                    src={require("./assests/Images/CpositiveIndrayani.jpeg")}
                                />
                                <p>Indrayani Hospital · Awardee</p>
                            </div>
                            <div className="moment-card">
                                <img alt="Award ceremony moment" src={require("./assests/Images/CpositveMegha.jpeg")} />
                                <p>Ms. Megha Deuskar · Awardee</p>
                            </div>
                            <div className="moment-card">
                                <img
                                    alt="Award ceremony moment"
                                    src={require("./assests/Images/CpositiveNamita.jpeg")}
                                />
                                <p>Ms. Namita Kohok · Awardee</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-inner fade-in">
                    <div className="edition-hero">
                        <div className="edition-content">
                            <span className="edition-kicker">C Positive Awards</span>
                            <h3>2024 Edition</h3>
                            <p className="edition-date">2 July 2024</p>
                            <p>
                                The inaugural edition under the C Positive initiative by Rising India Research
                                Foundation — celebrating individuals and organisations exemplifying Care, Compassion and
                                Courage.
                            </p>
                        </div>
                        <div className="edition-stats">
                            <div className="stat-box">
                                <span>100</span>
                                <p>attendees</p>
                            </div>
                            <div className="stat-box">
                                <span>4</span>
                                <p>awardees</p>
                            </div>
                        </div>
                    </div>
                    <div className="guest-section">
                        <div className="small-label">Guests of Honour</div>
                        <div className="guest-grid">
                            <div className="guest-card">
                                <div className="guest-photo">
                                    <img alt="Shekhar Kulkarni" src={require("./assests/Images/ShekharKulkarni.png")} />
                                </div>
                                <span className="guest-role">Chief Guest</span>
                                <h4>Dr. Shekhar Kulkarni</h4>
                                <p>Consultant Breast Surgeon & Oncologist</p>
                            </div>
                            <div className="guest-card">
                                <div className="guest-photo">
                                    <img
                                        alt="Dr. Vibha Bafna receiving award"
                                        src={require("./assests/Images/DeglurkarSir.png")}
                                    />
                                </div>
                                <span className="guest-role">Chief Guest</span>
                                <h4>Dr. G.B. Deglurkar</h4>
                                <p>Archaeologist, Former Chancellor, Deccan College</p>
                            </div>
                        </div>
                    </div>
                    <div className="moments-section">
                        <div className="small-label">Moments from 2024</div>
                        <div className="moments-grid">
                            <div className="moment-card">
                                <img
                                    alt="Dr. Vibha Bafna receiving award"
                                    src={require("./assests/Images/VibhaMamAward.jpeg")}
                                />
                                <p>Dr. Vibha Bafna · Awardee</p>
                            </div>
                            <div className="moment-card">
                                <img
                                    alt="Ms. Supriya Shinde receiving award"
                                    src={require("./assests/Images/SupriyaShinde.jpeg")}
                                />
                                <p>Ms. Supriya Shinde · Awardee</p>
                            </div>
                            <div className="moment-card">
                                <img
                                    alt="Mr. Prathamesh receiving award"
                                    src={require("./assests/Images/Prathamesh.jpeg")}
                                />
                                <p>Mr. Prathamesh Sinha · Awardee</p>
                            </div>
                            <div className="moment-card">
                                <img
                                    alt="Ms. Aishwarya Bhosale receiving award"
                                    src={require("./assests/Images/AishwaryaBhosale.jpeg")}
                                />
                                <p>Ms. Aishwarya Bhosale · Awardee</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section id="past-edition-2024"></section> */}
            <section id="nominate">
                <div className="section-inner fade-in">
                    <div className="section-label">Nominations Open</div>
                    <h2 className="section-title">
                        Submit Your&nbsp;
                        <em>Nomination</em>
                    </h2>
                    <p style={{maxWidth: "600px", color: "var(--text-mid)", fontSize: "0.97rem", lineHeight: "1.8"}}>
                        Know someone making an extraordinary difference in cancer care? Take five minutes to nominate
                        them — it could change their life and inspire thousands.
                    </p>
                    <form className="form-wrapper" id="nomination-form" onSubmit={handleSubmit}>
                        <div className="form-header">
                            <h3>C Positive Awards 2026 — Nomination Form</h3>
                            <p>
                                Third Edition · Fields marked with * are required. All information is treated with
                                strict confidentiality.
                            </p>
                        </div>
                        <div className="form-body">
                            {/* SECTION A */}
                            {/* SECTION A */}
                            <div className="form-section-title">
                                <div className="form-section-num">A</div>
                                Nominator Details
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>
                                        Full Name <span className="required">*</span>
                                    </label>

                                    <input type="text" name="nominatorFullName" placeholder="Your full name" required />
                                </div>

                                <div className="form-group">
                                    <label>Professional Designation</label>

                                    <input
                                        type="text"
                                        name="nominatorProfessionalDesignation"
                                        placeholder="e.g. Senior Oncologist, Nurse, Patient"
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>
                                        Email Address <span className="required">*</span>
                                    </label>

                                    <input type="email" name="nominatorEmailId" placeholder="your@email.com" required />
                                </div>

                                <div className="form-group">
                                    <label>
                                        Mobile Number <span className="required">*</span>
                                    </label>

                                    <input type="tel" name="nominatorMobileNo" placeholder="+91 XXXXX XXXXX" required />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Organisation / Affiliation</label>

                                    <input
                                        type="text"
                                        name="nominatorOrganisationAffiliation"
                                        placeholder="Hospital, institution, or organisation name"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>
                                        City & State <span className="required">*</span>
                                    </label>

                                    <input
                                        type="text"
                                        name="nominatorStateCity"
                                        placeholder="e.g. Pune, Maharashtra"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>
                                        Your Relationship to the Nominee <span className="required">*</span>
                                    </label>

                                    <select name="nominatorRelationshipToNominee" required>
                                        <option value="" disabled selected>
                                            Select relationship
                                        </option>

                                        <option>Colleague / Professional Peer</option>
                                        <option>Patient / Caregiver</option>
                                        <option>Senior / Mentor</option>
                                        <option>Student / Mentee</option>
                                        <option>Community Member / Public</option>
                                        <option>Self-Nomination</option>
                                        <option>Other</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>How did you hear about the C Positive Awards?</label>

                                    <select name="nominatorHearAboutAwardsSource">
                                        <option value="" disabled selected>
                                            Select source
                                        </option>

                                        <option>Social Media</option>
                                        <option>Colleague / Word of Mouth</option>
                                        <option>Email Newsletter</option>
                                        <option>News / Media</option>
                                        <option>Hospital / Institution</option>
                                        <option>Previous Editions</option>
                                        <option>Other</option>
                                    </select>
                                </div>
                            </div>
                            {/* SECTION B */}
                            <div className="form-section-title">
                                <div className="form-section-num">A</div>
                                Nominee Details
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>
                                        Nominee's Full Name
                                        <span className="required">*</span>
                                    </label>
                                    <input
                                        name="nomineeName"
                                        placeholder="Full name of the person or institution being nominated"
                                        required
                                        type="text"
                                    />
                                </div>
                                <div className="form-group">
                                    <label>
                                        Nominee's Age
                                        <span className="required">*</span>
                                    </label>

                                    <input
                                        name="Age"
                                        type="number"
                                        min="5"
                                        max="120"
                                        placeholder="Enter nominee age"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group" style={{width: "100%"}}>
                                    <label>
                                        Award Category
                                        <span className="required">*</span>
                                    </label>

                                    <select name="awardCategory" required style={{width: "100%"}}>
                                        <option disabled value="">
                                            Select award category
                                        </option>
                                        <option>CAT 01 — Patient Courage Award</option>
                                        <option>CAT 02 — Psycho-Oncology Excellence Award</option>
                                        <option>CAT 03 — Institutional Excellence in Cancer Care</option>
                                        <option>CAT 04 — NGO / Community Impact Award</option>
                                        <option>CAT 05 — Excellence in Oncology Award</option>
                                        <option>CAT 06 — Corporate Impact Award</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>
                                        Type of Nomination
                                        <span className="required">*</span>
                                    </label>
                                    <select name="nominationType" required>
                                        <option disabled value="">
                                            Individual or Institution
                                        </option>
                                        <option>Individual</option>
                                        <option>Institution / Organisation</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Nominee's Specialisation / Field</label>
                                    <input
                                        name="specialization"
                                        placeholder="e.g. Surgical Oncology, Haematology, Palliative Care"
                                        type="text"
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Nominee's Current Organisation</label>
                                    <input
                                        name="organization"
                                        placeholder="Hospital, institution, or organisation"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>
                                        Nominee's Email Address
                                        <span className="required">*</span>
                                    </label>
                                    <input name="email" placeholder="nominee@email.com" required type="email" />
                                </div>
                                <div className="form-group">
                                    <label>
                                        Nominee's Contact Number
                                        <span className="required">*</span>
                                    </label>
                                    <input name="contactNumber" placeholder="+91 XXXXX XXXXX" required type="tel" />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>
                                        Nominee's City & State
                                        <span className="required">*</span>
                                    </label>
                                    <input
                                        name="cityState"
                                        placeholder="e.g. Mumbai, Maharashtra"
                                        required
                                        type="text"
                                    />
                                </div>
                                <div className="form-group">
                                    <label>
                                        Years of Contribution in Cancer Care
                                        <span className="required">*</span>
                                    </label>
                                    <select name="yearsContribution" required>
                                        <option disabled value="">
                                            Select duration
                                        </option>
                                        <option>Less than 3 years</option>
                                        <option>3 – 5 years</option>
                                        <option>5 – 10 years</option>
                                        <option>10 – 20 years</option>
                                        <option>20 – 30 years</option>
                                        <option>30+ years</option>
                                    </select>
                                </div>

                                {/* <div class="form-group">
              <label>Nominee's Date of Birth (for Age-Restricted Categories)</label>
              <input type="date">
            </div> */}
                            </div>
                            {/* SECTION C */}
                            <div className="form-section-title">
                                <div className="form-section-num">B</div>
                                Nomination Statement
                            </div>
                            {/* <div class="form-row single">
            <div class="form-group">
              <label>In one sentence, why does this person/institution deserve the C Positive Award? <span
                  class="required">*</span></label>
              <input type="text" placeholder="A concise, compelling summary (max 150 characters)">
              <span class="char-hint">Max 150 characters</span>
            </div>
          </div> */}
                            <div className="form-row single">
                                <div className="form-group">
                                    <label>
                                        Describe the nominee's contribution in detail
                                        <span className="required">*</span>
                                    </label>

                                    <textarea
                                        name="contributionDetails"
                                        placeholder="Please provide a detailed account (500–800 words) of the nominee's work, impact, innovation, or service to cancer care. Include specific examples, outcomes achieved, and the scale of impact where possible."
                                        required
                                        rows="6"
                                        onChange={(e) => {
                                            const words = e.target.value.trim().split(/\s+/).filter(Boolean);

                                            if (words.length > 800) {
                                                e.target.value = words.slice(0, 800).join(" ");
                                                setWordCount(800);
                                            } else {
                                                setWordCount(words.length);
                                            }
                                        }}
                                    ></textarea>

                                    <div className="word-count-row">
                                        <span className="char-hint">Recommended: 500 – 800 words</span>

                                        <span
                                            style={{fontSize: "12px"}}
                                            className={`word-count ${
                                                wordCount < 500 ? "low" : wordCount <= 800 ? "valid" : "invalid"
                                            }`}
                                        >
                                            &nbsp;({wordCount}/800 words)
                                        </span>
                                    </div>
                                </div>
                            </div>{" "}
                            {/* <div class="form-row single">
            <div class="form-group">
              <label>How has the nominee's work impacted patients, families, or the broader cancer community? <span
                  class="required">*</span></label>
              <textarea rows="4"
                placeholder="Describe real-world impact with specific examples. Include patient numbers, geographic reach, research citations, policy changes, or other measurable outcomes."></textarea>
            </div>
          </div>

          <div class="form-row single">
            <div class="form-group">
              <label>What makes this nominee uniquely deserving of the award, compared to others in their field?</label>
              <textarea rows="4"
                placeholder="Highlight what sets the nominee apart — whether it is innovation, scale, adversity overcome, pioneering work, or exceptional dedication."></textarea>
            </div>
          </div>

          <div class="form-row single">
            <div class="form-group">
              <label>Notable Achievements, Publications, Awards, or Recognition (if any)</label>
              <textarea rows="3"
                placeholder="List any relevant peer recognition, publications, media features, or prior awards. Include links or references where available."></textarea>
            </div>
          </div> */}
                            {/* SECTION D */}
                            <div className="form-section-title">
                                <div className="form-section-num">C</div>
                                Supporting Documents
                            </div>
                            <div className="form-row single">
                                <div className="form-group">
                                    <label>
                                        Upload Nominee's CV / Institutional Profile
                                        <span className="required">*</span>
                                    </label>
                                    <input
                                        accept=".pdf,.doc,.docx"
                                        name="cv"
                                        required
                                        style={{
                                            background: "var(--cream)",
                                            border: "1px dashed rgba(0,0,0,0.2)",
                                            cursor: "pointer",
                                        }}
                                        type="file"
                                    />
                                    <span className="char-hint">PDF or Word, max 5MB</span>
                                </div>
                                <div className="form-group">
                                    <label>
                                        Upload Nominee's Photograph or Logo
                                        <span className="required">*</span>
                                    </label>
                                    <input
                                        accept="image/*"
                                        name="photo"
                                        required
                                        style={{
                                            background: "var(--cream)",
                                            border: "1px dashed rgba(0,0,0,0.2)",
                                            cursor: "pointer",
                                        }}
                                        type="file"
                                    />
                                    <span className="char-hint">JPG/PNG, minimum 300 DPI, max 5MB</span>
                                </div>
                            </div>
                            <div className="form-row single">
                                <div className="form-group">
                                    <label>
                                        Upload Supporting Letter
                                        <span className="required">*</span>
                                    </label>
                                    <input
                                        accept=".pdf,.doc,.docx"
                                        name="supportLetter"
                                        required
                                        style={{
                                            background: "var(--cream)",
                                            border: "1px dashed rgba(0,0,0,0.2)",
                                            cursor: "pointer",
                                        }}
                                        type="file"
                                    />
                                    <span className="char-hint">On official letterhead. PDF or Word, max 5MB.</span>
                                </div>
                            </div>
                            {/* <div class="form-row single">
            <div class="form-group">
              <label>Upload Supporting Letter 2 <span class="required">*</span></label>
              <input type="file" accept=".pdf,.doc,.docx"
                style="background:var(--cream); border:1px dashed rgba(0,0,0,0.2); cursor:pointer;">
              <span class="char-hint">On official letterhead. PDF or Word, max 5MB.</span>
            </div>
          </div> */}
                            <div className="form-row single">
                                <div className="form-group">
                                    <label>Upload Additional Evidence (optional)</label>
                                    <input
                                        accept=".pdf,.jpg,.png,.mp4,.pptx"
                                        multiple
                                        name="additionalEvidence"
                                        style={{
                                            background: "var(--cream)",
                                            border: "1px dashed rgba(0,0,0,0.2)",
                                            cursor: "pointer",
                                        }}
                                        type="file"
                                    />
                                    <span className="char-hint">
                                        Publications, case studies, media clippings, video links. Max 10MB total.
                                    </span>
                                </div>
                            </div>
                            <div className="form-row single">
                                <div className="form-group">
                                    <label>
                                        Any links to relevant media coverage, publications, or portfolio (optional)
                                    </label>
                                    <textarea
                                        name="mediaLinks"
                                        placeholder="Paste any relevant URLs, one per line."
                                        rows="3"
                                    ></textarea>
                                </div>
                            </div>
                            {/* SECTION E: CONSENT */}
                            <div className="form-section-title">
                                <div className="form-section-num">D</div>
                                Declaration & Consent
                            </div>
                            <div className="consent-block">
                                <div className="consent-item">
                                    <input id="c1" name="consentAccuracy" required type="checkbox" />
                                    <label htmlFor="c1">
                                        I confirm that all information provided in this nomination is accurate and
                                        complete to the best of my knowledge. I understand that any false or misleading
                                        information will result in immediate disqualification.
                                        <span className="required">*</span>
                                    </label>
                                </div>
                                <div className="consent-item">
                                    <input id="c2" name="consentNominee" required type="checkbox" />
                                    <label htmlFor="c2">
                                        I confirm that I have the consent of the nominee (or their authorised
                                        representative) to submit this nomination and share their personal details with
                                        the C Positive Awards organisers.
                                        <span className="required">*</span>
                                    </label>
                                </div>
                                <div className="consent-item">
                                    <input id="c3" name="consentPublish" required type="checkbox" />
                                    <label htmlFor="c3">
                                        I agree that if the nominee is selected as a finalist or winner, their name,
                                        photograph, and a summary of their work may be published on the awards website,
                                        social media, and in press communications.
                                        <span className="required">*</span>
                                    </label>
                                </div>
                                <div className="consent-item">
                                    <input id="c4" name="consentJury" type="checkbox" />
                                    <label htmlFor="c4">
                                        I understand that the jury's decision is final and binding, and that no
                                        correspondence will be entered into regarding the outcome of nominations.
                                    </label>
                                </div>
                                <div className="consent-item">
                                    <input id="c5" name="consentUpdates" type="checkbox" />
                                    <label htmlFor="c5">
                                        I agree to receive updates about the C Positive Awards 2026 via email or phone
                                        (you may unsubscribe at any time).
                                    </label>
                                </div>
                            </div>
                            <div className="form-submit">
                                <button className="btn-submit" type="submit" disabled={loading}>
                                    Submit Nomination
                                    <span className="arrow">→</span>
                                </button>
                                <p className="submit-note">
                                    You will receive a confirmation email within 24 hours.
                                    <br />
                                    Queries:
                                    <strong>cpositiveawards@gmail.com</strong>
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
            {/* <section id="judging">
                <div className="section-inner fade-in">
                    <div className="section-label">Evaluation Process</div>
                    <h2 className="section-title">
                        Judging &&nbsp;<em>Scoring</em>
                    </h2>
                    <div className="judging-grid">
                        <div>
                            <p
                                style={{
                                    color: "var(--text-mid)",
                                    fontSize: "0.97rem",
                                    lineHeight: "1.8",
                                    marginBottom: "2rem",
                                }}
                            >
                                All nominations are evaluated by an independent, multi-disciplinary jury comprising
                                senior oncologists, patient advocates, healthcare administrators, researchers, and
                                public health experts.
                            </p>
                            <div className="judging-process">
                                <div className="jp-step">
                                    <div className="jp-num">01</div>
                                    <div>
                                        <h4>Eligibility Screening</h4>
                                        <p>
                                            The secretariat verifies that all submissions meet the published eligibility
                                            criteria and documentation requirements.
                                        </p>
                                    </div>
                                </div>
                                <div className="jp-step">
                                    <div className="jp-num">02</div>
                                    <div>
                                        <h4>Independent Blind Review</h4>
                                        <p>
                                            Each eligible nomination is scored independently by at least three jury
                                            members who do not know the nominator's identity.
                                        </p>
                                    </div>
                                </div>
                                <div className="jp-step">
                                    <div className="jp-num">03</div>
                                    <div>
                                        <h4>Jury Panel Discussion</h4>
                                        <p>
                                            Top-scoring nominations in each category are discussed by the full jury
                                            panel, with consensus required to select finalists.
                                        </p>
                                    </div>
                                </div>
                                <div className="jp-step">
                                    <div className="jp-num">04</div>
                                    <div>
                                        <h4>Winners Decided</h4>
                                        <p>
                                            The jury selects one winner per category. In exceptional cases, the jury may
                                            award a Special Commendation.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="criteria-box">
                            <h3>Scoring Criteria</h3>
                            <div className="criteria-item">
                                <div className="criteria-bar">
                                    <span className="criteria-pct">30%</span>
                                </div>
                                <div className="criteria-info">
                                    <h4>Impact & Outcomes</h4>
                                    <p>
                                        Measurable improvement in patient care, survival rates, access, or quality of
                                        life.
                                    </p>
                                </div>
                            </div>
                            <div className="criteria-item">
                                <div className="criteria-bar">
                                    <span className="criteria-pct">25%</span>
                                </div>
                                <div className="criteria-info">
                                    <h4>Innovation & Originality</h4>
                                    <p>
                                        Novel approaches, pioneering methods, or creative solutions to cancer care
                                        challenges.
                                    </p>
                                </div>
                            </div>
                            <div className="criteria-item">
                                <div className="criteria-bar">
                                    <span className="criteria-pct">20%</span>
                                </div>
                                <div className="criteria-info">
                                    <h4>Scale & Reach</h4>
                                    <p>
                                        Number of patients served, geographic spread, and sustainability of the
                                        contribution.
                                    </p>
                                </div>
                            </div>
                            <div className="criteria-item">
                                <div className="criteria-bar">
                                    <span className="criteria-pct">15%</span>
                                </div>
                                <div className="criteria-info">
                                    <h4>Commitment & Dedication</h4>
                                    <p>
                                        Depth and duration of commitment to the cause, especially under challenging
                                        conditions.
                                    </p>
                                </div>
                            </div>
                            <div className="criteria-item">
                                <div className="criteria-bar">
                                    <span className="criteria-pct">10%</span>
                                </div>
                                <div className="criteria-info">
                                    <h4>Peer Recognition</h4>
                                    <p>
                                        Esteem within the professional community, publications, citations, or
                                        institutional acknowledgement.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section id="faq">
                <div className="section-inner fade-in">
                    <div className="section-label">Frequently Asked Questions</div>
                    <h2 className="section-title">
                        Common&nbsp;
                        <em>Questions</em>
                    </h2>
                    <div className="faq-grid">
                        <div className="faq-item">
                            <h4>Can I nominate more than one person?</h4>
                            <p>
                                Yes. A single nominator may submit up to three nominations, each in a different
                                category. Each nomination must be submitted as a separate form with complete
                                documentation.
                            </p>
                        </div>
                        <div className="faq-item">
                            <h4>Is there a nomination fee?</h4>
                            <p>
                                No. Nominations for the C Positive Awards are completely free of charge. The awards are
                                supported by philanthropic grants and institutional partnerships, never by nominee fees.
                            </p>
                        </div>
                        <div className="faq-item">
                            <h4>Can I nominate someone from outside India?</h4>
                            <p>Yes. Nominations are open to individuals and organizations within and outside India.</p>
                        </div>
                        <div className="faq-item">
                            <h4>What happens after I submit a nomination?</h4>
                            <p>
                                You will receive a confirmation email upon submitting the nomination. The review
                                committee will contact you if any additional information is required. Award winners will
                                be notified by 20 June 2026 via email.
                            </p>
                        </div>
                        <div className="faq-item">
                            <h4>Will the nominee know I nominated them?</h4>
                            <p>
                                Nominators may choose whether to inform nominees. We recommend doing so, as nominees who
                                are aware of their nomination can provide additional supporting materials if requested
                                by the jury.
                            </p>
                        </div>
                        <div className="faq-item">
                            <h4>Can an organisation nominate one of its own staff?</h4>
                            <p>
                                Yes. Organisations may nominate staff members, provided the nominator is not a direct
                                family member and the nomination is free of commercial conflict of interest.
                            </p>
                        </div>
                        {/* <div className="faq-item">
                            <h4>How is the jury selected?</h4>
                            <p>
                                The jury is an independent panel appointed by the C Positive Awards Advisory Council.
                                Members are senior professionals in oncology, public health, patient advocacy, and
                                healthcare management. Jury members recuse themselves from categories where they have a
                                conflict of interest.
                            </p>
                        </div> */}
                        <div className="faq-item">
                            <h4>Will there be public voting?</h4>
                            <p>
                                The C Positive Awards are a merit-based, jury-decided honour. There is no public vote,
                                ensuring recognition is based on demonstrated impact rather than social media reach.
                            </p>
                        </div>
                        <div className="faq-item">
                            <h4>Can I edit or withdraw a nomination after submission?</h4>
                            <p>
                                Nominations can be edited up to the closing deadline by contacting the review committee.
                                Withdrawal requests may be submitted by either the nominator or the nominee at any time
                                before 19th June via email.
                            </p>
                        </div>
                        <div className="faq-item">
                            <h4>What does the award recipient receive?</h4>
                            <p>
                                Award recipients will receive a commemorative trophy, a personalised citation in
                                recognition of their contribution to cancer care. Selected awardees may also be invited
                                as speakers at future cancer care events. There is no cash prize associated with the
                                award.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section id="contact">
                <div className="contact-inner">
                    <div className="contact-body">
                        <div className="section-label">Get in Touch</div>
                        <h2 className="section-title">
                            Contact&nbsp;
                            <em>Us</em>
                        </h2>
                        <p>
                            Have questions about the nomination process, award categories, or the ceremony? Our team is
                            here to help. Reach out to the C Positive Awards team.
                        </p>
                        <div className="contact-items">
                            <div className="contact-item">
                                <div className="contact-icon">✉</div>
                                <div className="contact-item-body">
                                    <h5>Email</h5>
                                    <p>cpositiveawards@gmail.com</p>
                                </div>
                            </div>
                            <div className="contact-item">
                                <div className="contact-icon">☎</div>
                                <div className="contact-item-body">
                                    <h5>Phone (Nominations Helpdesk)</h5>
                                    <p>+91 9545300800 · Mon–Fri, 10am–6pm IST</p>
                                </div>
                            </div>
                            <div className="contact-item">
                                <div className="contact-icon">📍</div>
                                <div className="contact-item-body">
                                    <h5>Address</h5>
                                    <p>
                                        17, 1st Floor, Lane No. 2, Paud Rd, near Krushna Hospital, Prashant Society,
                                        Kothrud, Pune, Maharashtra 411038
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="social-links" style={{marginTop: "2rem"}}>
                            <a
                                className="social-link"
                                href="https://www.instagram.com/risingindiaresearchfoundation/"
                                title="Instagram"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaInstagram />
                            </a>

                            <a
                                className="social-link"
                                href="https://www.linkedin.com/company/rising-india-research-foundation-in/"
                                title="LinkedIn"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaLinkedinIn />
                            </a>

                            <a
                                className="social-link"
                                href="https://www.facebook.com/people/Rising-India-Research-Foundation/100094089721870/"
                                title="Facebook"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaFacebookF />
                            </a>
                        </div>
                    </div>
                    <div className="contact-card">
                        <h3>Ceremony & Partnership</h3>
                        <p
                            style={{
                                fontSize: "0.88rem",
                                color: "rgba(255,255,255,0.55)",
                                lineHeight: "1.7",
                                marginBottom: "1.5rem",
                            }}
                        >
                            Interested in attending the ceremony, sponsoring the awards, or partnering with the C
                            Positive initiative? We welcome organisations committed to transforming cancer care.
                        </p>
                        <p
                            style={{
                                fontSize: "0.88rem",
                                color: "rgba(255,255,255,0.55)",
                                lineHeight: "1.7",
                                marginBottom: "0.4rem",
                            }}
                        >
                            <span
                                style={{
                                    color: "var(--gold-light)",
                                    fontSize: "0.75rem",
                                    letterSpacing: "0.1em",
                                    textTransform: "uppercase",
                                    display: "block",
                                    marginBottom: "0.2rem",
                                }}
                            >
                                Partnerships & Sponsorship
                            </span>
                            cpositiveawards@gmail.com
                        </p>
                        <p
                            style={{
                                fontSize: "0.88rem",
                                color: "rgba(255,255,255,0.55)",
                                lineHeight: "1.7",
                                marginTop: "1rem",
                            }}
                        >
                            <span
                                style={{
                                    color: "var(--gold-light)",
                                    fontSize: "0.75rem",
                                    letterSpacing: "0.1em",
                                    textTransform: "uppercase",
                                    display: "block",
                                    marginBottom: "0.2rem",
                                }}
                            >
                                Media & Press
                            </span>
                            cpositiveawards@gmail.com
                        </p>
                        <div
                            style={{
                                marginTop: "2rem",
                                paddingTop: "1.5rem",
                                borderTop: "1px solid rgba(255,255,255,0.08)",
                            }}
                        >
                            <p style={{fontSize: "0.8rem", color: "rgba(255,255,255,0.35)", lineHeight: "1.6"}}>
                                The C Positive Awards are a non-commercial, non-governmental initiative. All award
                                decisions are independent of sponsors and partners.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <footer>
                <div className="footer-inner">
                    <center>
                        <div className="footer-logo">C Positive Awards · Third Edition · June 2026</div>
                        <div className="footer-copy">© 2026 C Positive Awards. All rights reserved.</div>
                    </center>
                    {/* <div className="footer-links">
                        <a href="#">Privacy Policy</a>
                        <a href="#">Terms of Use</a>
                        <a href="#">Cookie Policy</a>
                        <a href="#contact">Contact</a>
                    </div> */}
                </div>
            </footer>
            {message && (
                <p className="api-message">
                    <strong>{message}</strong>
                </p>
            )}
            {loading && (
                <p className="api-message">
                    <strong>Submitting...</strong>
                </p>
            )}
        </>
    );
}
